import { render, staticRenderFns } from "./StatusRedirect.vue?vue&type=template&id=30b695db&"
import script from "./StatusRedirect.vue?vue&type=script&lang=js&"
export * from "./StatusRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports